export default __webpack_public_path__ + "static/media/government-of-Ireland.f1c20702.png";